import { ExportReportType } from '~/exportReport/exportReportType';
import { MapExportReportPreviewLocationComponent } from '~/map/page/exportReportPreview/mapExportReportPreviewLocation.component';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';

export const MapExportReportPreviewContainer = () => {
  const exportReportState = useToolsStateExportReportSelector();

  if (!exportReportState.isActive) {
    return null;
  }

  if (exportReportState.params.type === ExportReportType.Location) {
    return <MapExportReportPreviewLocationComponent params={exportReportState.params} template={exportReportState.template} />;
  }

  return null;
};
